/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-02-18",
    versionChannel: "nightly",
    buildDate: "2025-02-18T00:06:12.601Z",
    commitHash: "d7387abc6383b3c5d090a90c4dce1e17afa13d9b",
};
